import * as React from 'react';

import PwrPasswordChangeEndContainer from '../../containers/PwrPasswordChangeEnd';

/**
 * パスワードリマインダのパスワード変更完了
 * @param props
 */
const PasswordChangeEnd: React.FC<any> = props => {
	return (
		<>
			<PwrPasswordChangeEndContainer {...props} />
		</>
	);
};

export default PasswordChangeEnd;



// WEBPACK FOOTER //
// ./src/pages/pwr/PasswordChangeEnd.tsx